export default __webpack_public_path__ + "img/MicrosoftAzure-Logo-660x330.9e3a2d5e.png";